import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Card, CardBody, CardHeader, Label, Collapse, FormGroup, Input, Table, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { FaChevronRight, FaChevronLeft, FaChevronUp, FaChevronDown, FaTrash, FaPlus, FaUpload, FaSave } from 'react-icons/fa';
import FarmApt from './FarmApt';
import PriorityContaminants from './PriorityContaminants';
import CatchmentOverview from './CatchmentOverview';
import './CatchmentContext.css';
import axios from 'axios';
import OtherInfo from './OtherInfo';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import toast, { Toaster } from 'react-hot-toast';
import useAuth from "../Utilities/Hooks/useAuth";
import Documents from '../Uploads/Documents';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toPng } from 'html-to-image';
import { Tooltip as ReactTooltip } from "react-tooltip";
import BiodiversityInfo from './SignificantBiodiversity'
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const getBase64 = (file) => {
    return new Promise(resolve => {
        let baseURL = "";
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
};

const CatchmentContext = ({ refreshToken,handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const elementRef = useRef(null); const elementRef1 = useRef(null); const elementRef2 = useRef(null);
    const [isOpen, setIsOpen] = useState(false); const [isIconUp, setIsIconUp] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen);
        setIsIconUp(!isIconUp);
    }; const [saving, setSaving] = useState('');

    const [isOpen1, setIsOpen1] = useState(true); const [isIconUp1, setIsIconUp1] = useState(true);
    const toggle1 = () => {
        setIsOpen1(!isOpen1);
        setIsIconUp1(!isIconUp1);
    };

    const [roleName, setRoleName] = useState(localStorage.getItem("roleName"));
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);
    const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const [catchmentName, setCatchmentName] = useState('');
    const [farmDetails, setFarmDetails] = useState({ farmAddress: ''});
    const [regionalCouncilName, setRegionalCouncilName] = useState('');
    const [regionalCouncilRequirements, setRegionalCouncilRequirements] = useState('');
    const [catchmentContext, setCatchmentContext] = useState({ Section: 'CatchmentContext', SectionName: 'Catchment Context, Challenges and Values', isWizardCompleted: false, SectionObj: {}, });
    const [catchmentDescription, setCatchmentDescription] = useState('');
    const [regionalCouncilDescription, setRegionalCouncilDescription] = useState('');
    const [savedContaminantsList, setSavedContaminantsList] = useState('');
    const [catchmentImageUrl, setCatchmentImageUrl] = useState('');
    const [regionalCouncilImageUrl, setRegionalCouncilImageUrl] = useState('');
    const [catchmentExternalLink, setCatchmentExternalLink] = useState('');
    const [catchmentDocumentName, setCatchmentDocumentName] = useState('');
    const [subRegion, setSubRegion] = useState(''); const [showSubRegion, setShowSubRegion] = useState(false);
    const [catchmentDocumentRelativePath, setCatchmentDocumentRelativePath] = useState('');
    const [farmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId] = useState(localStorage.getItem("loggedInUserId"));
    const { auth } = useAuth();
    const [externalOrganisationLinkRows, setExternalOrganisationLinkRows] = useState([]);
    const [regionalCouncilExternalOrganisationLinkRows, setRegionalCouncilExternalOrganisationLinkRows] = useState([]);
    const [notRelevantToThisProperty, setNotRelevantToThisProperty] = useState(false);
    const [imageUploadList, setImageUploadList] = useState([]);
    const [imageViewPopup, setImageViewPopup] = useState({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    let inputFile = [];
    const [priorityContaminantSelectedValues, setPriorityContaminantSelectedValues] = useState('');
    const [overviewDescription, setOverviewDescription] = useState('');
    const [culturalValuesDescription, setCulturalValuesDescription] = useState('');
    const [freshwaterValuesPrioritiesOutcomes, setFreshwaterValuesPrioritiesOutcomes] = useState('');
    const [catchmentOverviewChanged, setCatchmentOverviewChanged] = useState(false);
    const [regionalCouncilDetailChanged, setRegionalCouncilDetailChanged] = useState(false);
    const [significantBiodiversityChanged, setSignificantBiodiversityChanged] = useState(false);
    const [otherInfoChanged, setOtherInfoChanged] = useState(false);
    const [biodiversityDesc, setBiodiversityDesc] = useState('');
    const [memberships, setMemberships] = useState('');
    const [description, setDescription] = useState('');
    const [contaminantPriorities, setContaminantPriorities] = useState('');

    const [savingCatchmentContext, setSavingCatchmentContext] = useState(false);
    const [savingNext, setSavingNext] = useState(false);
    const [savingBack, setSavingBack] = useState(false);

    const handleCatchmentContextSave = async (e, from, section, method) => {
        if (from == '') {
            setSavingCatchmentContext(true);
        }
        else if (from == 'Next') {
            setSavingNext(true);
        }
        else if (from == 'Back') {
            setSavingBack(true);
        }
        if (catchmentOverviewChanged) {
            await handleCatchmentOverviewSubmit(e);
        }
        if (regionalCouncilDetailChanged) {
            await handleRecordRowsSubmit1(e);
        }
        if (significantBiodiversityChanged) {
            await handleBioDiversitySubmit(e);
        }
        if (otherInfoChanged) {
            await handleOtherInfoSubmit(e);
        }
        await htmlToImageConvert(section, method);
        toast.success("Catchment Context Detail Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
        if (from == '') {
            setSavingCatchmentContext(false);
            refreshToken();
        }
        else if (from == 'Next') {
            setSavingNext(false);
        }
        else if (from == 'Back') {
            setSavingBack(false);
        }
        
    }

    const handleCatchmentOverviewSubmit = async (e) => {
        e.preventDefault()

        setSaving(true);
        var PriorityContaminants = priorityContaminantSelectedValues.toString();
        try {
            const response = await apiPost(
                '/api/catchmentContext/saveCatchmentOverview/',
                JSON.stringify(
                    {
                        overviewDescription, culturalValuesDescription, farmId, userId, freshwaterValuesPrioritiesOutcomes, PriorityContaminants,
                    }), {
                headers: { 'Content-Type': 'application/json' }
            });

            setTimeout(() => {
                setSaving(false);
            }, 1000)

            //toast.success("Catchment Overview Details Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });

        } catch (err) {
            setTimeout(() => {
                setSaving(false);
            }, 1000)

            if (!err?.response) {
                toast.error("No server response!");
            } else if (err.response?.status === 400) {
                toast.error("Saving Catchment Overview Details Failed!");
            } else {
                toast.error("Saving Catchment Overview Details Failed!");
            }
        }
    }

    const handleBioDiversitySubmit = async (e) => {
        e.preventDefault()

        try {
            const response = await apiPost(
                '/api/catchmentContext/saveBiodiversityInfo/',
                JSON.stringify(
                    {
                        Description: biodiversityDesc, farmId, userId
                    }), {
                headers: { 'Content-Type': 'application/json' }
            });

        } catch (err) {
            setTimeout(() => {
                setSaving(false);
            }, 1000)

            if (!err?.response) {
                toast.error("No server response!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else if (err.response?.status === 400) {
                toast.error("Saving Significant Biodiversity Info Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("Saving Significant Biodiversity Info Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    const handleOtherInfoSubmit = async (e) => {
        e.preventDefault()
        try {
            const response = await apiPost(
                '/api/catchmentContext/saveOtherInfo/',
                JSON.stringify(
                    {
                        memberships, contaminantPriorities, description, farmId, userId
                    }), {
                headers: { 'Content-Type': 'application/json' }
            });

        } catch (err) {
            setTimeout(() => {
                setSaving(false);
            }, 1000)

            if (!err?.response) {
                toast.error("No server response!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else if (err.response?.status === 400) {
                toast.error("Saving Other Catchment Info Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("Saving Other Catchment Info Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    useEffect(() => {
        setLoading(true);
        getCatchmentDetails();

    }, [])

    const closeDeleteItemPopup = async () => {
        setShowDeleteItemPopup(false);
    }

    const confirmDeleteItemPopup = async () => {
        const response = await apiGet(
            '/api/catchmentcontext/DeleteRegionalCouncilMapImage/', {
            params: { Id: deleteItemId, userId: userId, FarmId: farmId }
        }
        );
        if (response.data.status) {
            setRegionalCouncilDetailChanged(true);
            setImageUploadList(response.data.content);
            let tempErrors = [];
            setFormErrors(tempErrors);
            response.data.content.forEach(function (element) {
                const error = {
                    fileError: ''
                };
                tempErrors.push(error);
            });
            setFormErrors(tempErrors);
            setShowDeleteItemPopup(false);
        }
    }

    const getCatchmentDetails = async () => {
        try {

            const response = await apiGet(
                '/api/catchmentcontext/GetCatchmentDetails/',
                {
                    headers: {
                        "Authorization": `Bearer ${auth.token}`
                    },
                    params: {
                        farmId: farmId
                    },
                });
            setSubRegion(response?.data?.subRegion);
            setShowSubRegion(response?.data?.showSubRegion);
            setRegionalCouncilRequirements(response?.data?.regionalCouncilRequirements);
            setCatchmentName(response?.data?.name);
            setRegionalCouncilName(response?.data?.regionalCouncilName);
            setCatchmentDescription(response?.data?.description);
            setRegionalCouncilDescription(response?.data?.regionalCouncilDescription);
            setCatchmentImageUrl(response?.data?.imageUrl);
            setRegionalCouncilImageUrl(response?.data?.regionalCouncilImageUrl);
            setCatchmentContext({ ...catchmentContext, isWizardCompleted: response?.data?.isFWFPCompleted, SectionObj: response?.data?.section });
            setCatchmentExternalLink(response?.data?.externalLink);
            setCatchmentDocumentName(response?.data?.catchmentDocumentName);
            setCatchmentDocumentRelativePath(response?.data?.catchmentDocumentRelativePath);
            setSavedContaminantsList(response?.data?.savedContaminantList);
            setNotRelevantToThisProperty(response?.data?.surfaceWaterQualityNotRelevantToThisProperty);
            setIsOpen(!response?.data?.surfaceWaterQualityNotRelevantToThisProperty);
            setExternalOrganisationLinkRows(response?.data?.externalOrganisationLinks);
            setRegionalCouncilExternalOrganisationLinkRows(response?.data?.regionalCouncilExternalOrganisationLinks);
            setImageUploadList(response.data.regionalCouncilMapImages);
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0 != null) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            if (response?.data?.farmAddress != "") {
                setFarmDetails({
                    ...farmDetails, farmAddress: response?.data?.farmAddress
                })
            }
            
            setLoading(false);

        } catch (error) {
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message);
            } else {
                toast.error("No server response");
            }
            setLoading(false);
        }
    }

    const handleImageChange = async (e,idx) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file.type != 'image/png' && file.type != 'image/jpeg' && file.type != 'image/jpg') {
            toast.error("Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            return false;
        }
        else if ((file.size / (1024 * 1024)) > 5) {
            toast.error("Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            return false;
        }
        getBase64(file)
            .then(result => {
                let form = {
                    FileName: file.name.replace(/\.[^/.]+$/, ""),
                    Base64Image: result,
                    farmId: farmId,
                    userId: userId
                }
                const response = apiPost(
                    '/api/catchmentcontext/UploadImage/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }).then(res => {
                        if (res.data != null) {
                            if (res.data.status) {
                                //toast.success("Images Saved!", { duration: 2000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                                const tempRows = [...imageUploadList];
                                tempRows[idx].imageName = res.data.content.FileName;
                                tempRows[idx].imagePhysicalName = res.data.content.PhysicalFilename;
                                tempRows[idx].imagePath = res.data.content.PhysicalFilepath;
                                tempRows[idx].imageRelativePath = res.data.content.RelativeFilepath;
                                setImageUploadList(tempRows);
                                setRegionalCouncilDetailChanged(true);
                            }
                        }
                    });
            })
            .catch(err => {
                console.log(err);
            });

        reader.onloadend = () => {
            e.target.value = null;
        }

        reader.readAsDataURL(file)
    }

    const handleBtnUploadClick = async (e, idx) => {
        e.preventDefault();
        inputFile[idx].click();
        return false;
    }

    const handleNotRelevantToThisProperty = async (event) => {
        setNotRelevantToThisProperty(event.target.checked);
        const response = await apiGet(
            '/api/catchmentcontext/UpdateNotRelevantToThisProperty/',
            {
                params: {
                    FarmId: farmId, NotRelevantToThisProperty: event.target.checked
                },
            });
    }
    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setRegionalCouncilRequirements(value)
        setRegionalCouncilDetailChanged(true);
    }
    const handleSubRegionChange  = async  (e) => {
        const { value} = e.target;
        let form = {
            FarmId: farmId,
            userId: userId,
            Images: null,
            SubRegion: value
        }
        const response = await apiPost(
            '/api/catchmentcontext/SaveSubRegion/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
            }
        }
        setSubRegion(value)
    }
    const handleImageViewPopup = (event, imageName, imageUrl) => {
        setImageViewPopup({ showImageViewPopup: true, imageName: imageName, imageUrl: imageUrl });
    }

    const handleImageViewPopupClose = (event) => {
        setImageViewPopup({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    }
    const [showDeleteItemPopup, setShowDeleteItemPopup] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(0);
    const openDeleteItemPopup = async (item) => {
        setShowDeleteItemPopup(true);
        setDeleteItemId(item.id);
    }
    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }
    const handleDateChange = (idx, date) => {
        const tempRows = [...imageUploadList];
        tempRows[idx].uploadDateText = getParsedDate(date);
        tempRows[idx].uploadDate = getDateFromString(getParsedDate(date));
        setImageUploadList(tempRows);
    };
    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }
    const handleNameChange = idx => e => {
        const tempRows = [...imageUploadList];
        tempRows[idx].name = e.target.value;
        setImageUploadList(tempRows);
        setRegionalCouncilDetailChanged(true);
    };
    const handleDetailChange = idx => e => {
        const tempRows = [...imageUploadList];
        tempRows[idx].detail = e.target.value;
        setImageUploadList(tempRows);
        setRegionalCouncilDetailChanged(true);
    };

    const getParsedDate1 = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }
    const [formErrors, setFormErrors] = useState([]);
    const handleRecordRowsAddRow = () => {
        setRegionalCouncilDetailChanged(true);
        const item = {
            uploadDate: null,
            detail: "", id: 0, name: '', imagePhysicalName: '', imagePath: '', imageRelativePath: '', imageName: ''
        };
        const error = {
            fileError: ''
        };
        setFormErrors([...formErrors, error]);
        setImageUploadList([...imageUploadList, item]);
    };

    const handleRecordRowsSubmit = async (e) => {
        setSaving(true);
        let tempRecordUploadList = [...imageUploadList];
        let form = {
            FarmId: farmId,
            userId: userId,
            Images: [],
            RegionalCouncilRequirements: regionalCouncilRequirements, SubRegion: subRegion
        }
        for (var i = 0; i < tempRecordUploadList.length; i++) {
            if (tempRecordUploadList[i].imageName != '' && tempRecordUploadList[i].imageName != null && tempRecordUploadList[i].imageName != undefined) {
                var obj = {};
                obj.Id = tempRecordUploadList[i].id;
                obj.Name = tempRecordUploadList[i].name;
                obj.Detail = tempRecordUploadList[i].detail;
                obj.ImageDetail = tempRecordUploadList[i].imageDetail;
                obj.ImageName = tempRecordUploadList[i].imageName;
                obj.ImagePhysicalName = tempRecordUploadList[i].imagePhysicalName;
                obj.ImagePath = tempRecordUploadList[i].imagePath;
                obj.UploadDateText = tempRecordUploadList[i].uploadDate != null ? tempRecordUploadList[i].uploadDateText : "";
                form.Images.push(obj);
            }
        }
        const response = await apiPost(
            '/api/catchmentcontext/SaveRegionalCouncilDetails/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                setImageUploadList(response.data.content);
                let tempErrors = [];
                setFormErrors(tempErrors);
                response.data.content.forEach(function (element) {
                    const error = {
                        fileError: ''
                    };
                    tempErrors.push(error);
                });
                setFormErrors(tempErrors);
                setSaving(false);
            }
        }
    };
    const handleRecordRowsSubmit1 = async () => {
        let form = {
            FarmId: farmId,
            userId: userId,
            Images: [],
            RegionalCouncilRequirements: regionalCouncilRequirements, SubRegion: subRegion
        }
        let tempRecordUploadList = [...imageUploadList];
        for (var i = 0; i < tempRecordUploadList.length; i++) {
            if (tempRecordUploadList[i].imageName != '' && tempRecordUploadList[i].imageName != null && tempRecordUploadList[i].imageName != undefined) {
                var obj = {};
                obj.Id = tempRecordUploadList[i].id;
                obj.Name = tempRecordUploadList[i].name;
                obj.Detail = tempRecordUploadList[i].detail;
                obj.ImageDetail = tempRecordUploadList[i].imageDetail;
                obj.ImageName = tempRecordUploadList[i].imageName;
                obj.ImagePhysicalName = tempRecordUploadList[i].imagePhysicalName;
                obj.ImagePath = tempRecordUploadList[i].imagePath;
                obj.UploadDateText = tempRecordUploadList[i].uploadDate != null ? tempRecordUploadList[i].uploadDateText : "";
                form.Images.push(obj);
            }
        }
        const response = await apiPost(
            '/api/catchmentcontext/SaveRegionalCouncilDetails/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                setImageUploadList(response.data.content);
                let tempErrors = [];
                setFormErrors(tempErrors);
                response.data.content.forEach(function (element) {
                    const error = {
                        fileError: ''
                    };
                    tempErrors.push(error);
                });
                setFormErrors(tempErrors);
            }
        }
    };

    const htmlToImageConvert = async (section, method) => {
        var WaterTestSitesImage1 = null;
        var WaterTestSitesImage2 = null;
        var WaterTestSitesImage3 = null;
        toPng(elementRef.current, { cacheBust: true})
            .then((dataUrl) => {
                WaterTestSitesImage1 = dataUrl;

                toPng(elementRef2.current, { cacheBust: true })
                    .then((dataUrl) => {
                        WaterTestSitesImage3 = dataUrl;

                        let form = {
                            WaterTestSitesImage1: WaterTestSitesImage1,
                            WaterTestSitesImage2: WaterTestSitesImage2,
                            WaterTestSitesImage3: WaterTestSitesImage3,
                            FarmId: farmId
                        }
                        const response = apiPost(
                            '/api/upload/UploadCatchemntImage/', JSON.stringify(form),
                            {
                                headers: { 'Content-Type': 'application/json' },
                                withCredentials: true
                            }).then(res => {
                                
                                if (method == 'handleWizardChanged') {
                                    handleWizardChanged(section);
                                }
                                else if (method == 'handleMoveToNextPage') {
                                    handleMoveToNextPage(section);
                                }
                                else if (method == 'handleWizardChangedBack') {
                                    handleWizardChangedBack(section);
                                }
                            });
                    })
                    .catch((err) => {
                        if (method == 'handleWizardChanged') {
                            handleWizardChanged(section);
                        }
                        else if (method == 'handleMoveToNextPage') {
                            handleMoveToNextPage(section);
                        }
                        else if (method == 'handleWizardChangedBack') {
                            handleWizardChangedBack(section);
                        }
                    });

            })
            .catch((err) => {
                if (method == 'handleWizardChanged') {
                    handleWizardChanged(section);
                }
                else if (method == 'handleMoveToNextPage') {
                    handleMoveToNextPage(section);
                }
                else if (method == 'handleWizardChangedBack') {
                    handleWizardChangedBack(section);
                }
            });
    };

    const handlePageChange = async (e,section, method,from) => {
        await handleCatchmentContextSave(e, from, section, method)
    }
    const handlePageChangeNonAdmin = async (e, section, method, from) => {
        if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{catchmentContext.SectionName}</h3></Col>
                {catchmentContext.isWizardCompleted != true && !loading &&
                    <>
                        <Col>
                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                            <>
                                {savingNext ?
                                    <Button className="float-end btn-next-page" onClick={(e) => handlePageChange(e, catchmentContext.Section, 'handleWizardChanged','Next')}
                                        disabled
                                    >
                                        <Row>
                                            <Col sm="8">
                                                <span>
                                                    {' '}Processing
                                                </span>
                                            </Col>
                                            <Col sm="4">
                                                <Spinner size="sm">
                                                    Processing...
                                                </Spinner>
                                            </Col>
                                        </Row>
                                    </Button>
                                    :
                                    <Button className="float-end btn-next-page" onClick={(e) => handlePageChange(e, catchmentContext.Section, 'handleWizardChanged','Next')} >
                                        Next <FaChevronRight />
                                    </Button>
                                }
                                {savingCatchmentContext ?
                                    <Button className="float-end btn-next-page" onClick={(e) => handleCatchmentContextSave(e, '', '', '')}
                                        disabled
                                    >
                                        <Row>
                                            <Col sm="8">
                                                <span>
                                                    {' '}Saving
                                                </span>
                                            </Col>
                                            <Col sm="4">
                                                <Spinner size="sm">
                                                    Saving...
                                                </Spinner>
                                            </Col>
                                        </Row>
                                    </Button>
                                    :
                                    <Button className="float-end btn-next-page" onClick={(e) => handleCatchmentContextSave(e, '', '', '')} >
                                        Save 
                                    </Button>
                                }
                                {savingBack ?
                                    <Button className="float-end btn-next-page" onClick={(e) => handlePageChange(e, catchmentContext.Section, 'handleWizardChangedBack', 'Back')}
                                        disabled
                                    >
                                        <Row>
                                            <Col sm="8">
                                                <span>
                                                    {' '}Processing
                                                </span>
                                            </Col>
                                            <Col sm="4">
                                                <Spinner size="sm">
                                                    Processing...
                                                </Spinner>
                                            </Col>
                                        </Row>
                                    </Button>
                                    :
                                    <Button className="float-end btn-next-page" onClick={(e) => handlePageChange(e, catchmentContext.Section, 'handleWizardChangedBack', 'Back')} >
                                        Back <FaChevronLeft />
                                    </Button>
                                }
                            </>
                        }
                        {roleName != 'SWNZ Admin' && farmRoleName != 'SWNZ Admin' && farmRoleName != 'Manager' && isNextButtonVisible &&
                            <>
                                {savingNext ?
                                    <Button className="float-end btn-next-page" onClick={(e) => handlePageChangeNonAdmin(e, catchmentContext.Section, 'handleMoveToNextPage','Next')}
                                        disabled
                                    >
                                        <Row>
                                            <Col sm="8">
                                                <span>
                                                    {' '}Processing
                                                </span>
                                            </Col>
                                            <Col sm="4">
                                                <Spinner size="sm">
                                                    Processing...
                                                </Spinner>
                                            </Col>
                                        </Row>
                                    </Button>
                                    :
                                <Button className="float-end btn-next-page" onClick={(e) => handlePageChangeNonAdmin(e, catchmentContext.Section, 'handleMoveToNextPage','Next')} >
                                    Next <FaChevronRight />
                                </Button>
                                }
                                {savingBack ?
                                <Button className="float-end btn-next-page" onClick={(e) => handlePageChangeNonAdmin(e, catchmentContext.Section, 'handleWizardChangedBack', 'Back')}
                                        disabled
                                    >
                                        <Row>
                                            <Col sm="8">
                                                <span>
                                                    {' '}Processing
                                                </span>
                                            </Col>
                                            <Col sm="4">
                                                <Spinner size="sm">
                                                    Processing...
                                                </Spinner>
                                            </Col>
                                        </Row>
                                    </Button>
                                    :
                                <Button className="float-end btn-next-page" onClick={(e) => handlePageChangeNonAdmin(e, catchmentContext.Section, 'handleWizardChangedBack', 'Back')} >
                                        Back <FaChevronLeft />
                                    </Button>
                                }
                            </>
                        }
                        
                        

                        

                        </Col>
                    </>
                    
                }
            </Row>
            {loading ? <SpinnerContainer /> :
                <>
                    <Row xs="2">
                        <Col>
                            <Card className="my-4">
                                <CardBody>
                                    <Row>
                                        <Col sm="8">
                                            <h4>{catchmentName}</h4>
                                            <p>{catchmentDescription}</p>
                                        </Col>
                                        <Col sm="4">
                                            {catchmentImageUrl.split("Organisationalimages/")[1] != "" ?
                                                <img width="150px" src={catchmentImageUrl} className="rounded float-end" alt="Catchment Image"
                                                    onError={(e) => {
                                                        e.target.onerror = null
                                                        e.target.src = "/images/no-image.jpg"
                                                    }} />
                                                : <></>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <p>Contaminants of concern based on water quality state and trend data - <b>{savedContaminantsList}</b></p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="8">
                                            {externalOrganisationLinkRows.length > 0 && <div><Label className="label" for="externalLink">External Link : </Label>
                                                <br />
                                                {externalOrganisationLinkRows.map(item =>
                                                    <>
                                                        <Label className="" style={{ fontSize: "14px", marginLeft: "15px",marginBottom:"0rem" }}>
                                                            • <a className="linkNews" href={item.link} target='_blank' ><u>{item.name == null || item.name == '' ? item.link : item.name}</u></a>
                                                        </Label>
                                                        <br />
                                                    </>
                                                )}
                                            </div>}
                                            
                                        </Col>
                                        {catchmentDocumentRelativePath && <Col sm="4">
                                            <div className="catchmentDoc-style">
                                                <a href={catchmentDocumentRelativePath} target='_blank' title={catchmentDocumentName}>
                                                    <img width="50px" src="/images/PDF_icon.png" className="PDF_icon settings-image-style" ></img>
                                                    <br /><span className="clickMe-label">(Click to open)</span></a>
                                            </div>
                                        </Col>
                                        }
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card className="my-4">
                                <CatchmentOverview priorityContaminantSelectedValues={priorityContaminantSelectedValues}
                                    setPriorityContaminantSelectedValues={setPriorityContaminantSelectedValues}
                                    overviewDescription={overviewDescription} setOverviewDescription={setOverviewDescription}
                                    culturalValuesDescription={culturalValuesDescription} setCulturalValuesDescription={setCulturalValuesDescription}
                                    freshwaterValuesPrioritiesOutcomes={freshwaterValuesPrioritiesOutcomes}
                                    setFreshwaterValuesPrioritiesOutcomes={setFreshwaterValuesPrioritiesOutcomes}
                                    handleCatchmentOverviewSubmit={handleCatchmentOverviewSubmit} setCatchmentOverviewChanged={setCatchmentOverviewChanged}
                                />
                            </Card>
                            
                            <Row>
                            </Row>
                            <Row>
                                <OtherInfo setOtherInfoChanged={setOtherInfoChanged} memberships={memberships} setMemberships={setMemberships}
                                    contaminantPriorities={contaminantPriorities} setContaminantPriorities={setContaminantPriorities}
                                    description={description} setDescription={setDescription}
                                    SectionObj={catchmentContext.SectionObj} />
                            </Row>
                            
                        </Col>
                        <Col>
                            <Card className="my-4">
                                <CardBody>
                                    <Row>
                                        <Col sm="8">
                                            <h4>{regionalCouncilName}</h4>
                                            <p>{regionalCouncilDescription}</p>
                                        </Col>
                                        <Col sm="4">
                                            {regionalCouncilImageUrl != undefined && regionalCouncilImageUrl != null && regionalCouncilImageUrl.split("Organisationalimages/")[1] != "" ?
                                                <img width="150px" src={regionalCouncilImageUrl} className="rounded float-end" alt="Regional Council Image"
                                                    onError={(e) => {
                                                        e.target.onerror = null
                                                        e.target.src = "/images/no-image.jpg"
                                                    }} />
                                                : <></>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="8">
                                            {regionalCouncilExternalOrganisationLinkRows != undefined && regionalCouncilExternalOrganisationLinkRows != null && regionalCouncilExternalOrganisationLinkRows.length > 0 && <div><Label className="label" for="externalLink">External Link : </Label>
                                                <br />
                                                {regionalCouncilExternalOrganisationLinkRows.map(item =>
                                                    <>
                                                        <Label className="" style={{ fontSize: "14px", marginLeft: "15px", marginBottom: "0rem" }}>
                                                            • <a className="linkNews" href={item.link} target='_blank' ><u>{item.name == null || item.name == '' ? item.link : item.name}</u></a>
                                                        </Label>
                                                        <br />
                                                    </>
                                                )}
                                            </div>}
                                        </Col>
                                        {showSubRegion && <Col sm="4">
                                            <FormGroup className=''>
                                                <Label>Sub-Region</Label>
                                                <Input type="select" onChange={(e) => { handleSubRegionChange(e); setRegionalCouncilDetailChanged(true); } } name="subRegion" id="subRegion" value={subRegion}>
                                                    <option value={0} >Select</option>
                                                    <option value="N/A">N/A</option>
                                                    <option value="Selwyn">Selwyn Te Waihora</option>
                                                    <option value="Hinds">Hinds</option>
                                                    <option value="Waitaki">Waitaki</option>
                                                    <option value="Waimakariri">Waimakariri</option>
                                                    <option value="Orari-Temuka-Opihi-Pareora">Orari-Temuka-Opihi-Pareora</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>}
                                        
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <FormGroup>
                                                <Label for="sectionComment"><b>Add any detail or commentary around regional council requirements</b></Label>
                                                <Input type="textarea" onChange={handleSectionCommentChange} value={regionalCouncilRequirements} name="regionalCouncilRequirements" id="regionalCouncilRequirements" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Card className="my-4 card-header-outline">
                                                <CardHeader className="item-header card-header-click card-header-outline" onClick={toggle1}>
                                                    <Row>
                                                        <Col sm="11">
                                                            <h5>Upload an image of any relevant maps</h5>
                                                        </Col>
                                                        <Col sm="1" className="toggleoutline_lt">{isIconUp1 ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                                    </Row>
                                                </CardHeader>
                                                <Collapse isOpen={isOpen1}>
                                                    <CardBody>
                                                    
                                                    <Row style={{ marginTop: `15px`, marginBottom: `15px` }}>
                                                        <Col>
                                                            <Card>
                                                                <CardBody>
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Date</th>
                                                                                <th>Name</th>
                                                                                <th>Detail</th>
                                                                                <th>View</th>
                                                                                <th></th>
                                                                                    <th>{(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                                                    <> Delete
                                                                                    </>}
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        {imageUploadList != undefined && imageUploadList != null && imageUploadList.length > 0 &&
                                                                            <tbody>
                                                                                {imageUploadList.map((item, idx) => (
                                                                                    <tr>
                                                                                        <td style={{ display: "none" }}>{imageUploadList[idx].id}</td>
                                                                                        <td style={{ width: "15%" }}>
                                                                                            <DatePicker selected={imageUploadList[idx].uploadDate != null ? getDateFromString(moment(imageUploadList[idx].uploadDate).format("DD/MM/YYYY")) : null} onChange={(date) => { handleDateChange(idx, date); setRegionalCouncilDetailChanged(true); }}
                                                                                                showYearDropdown
                                                                                                dateFormatCalendar="MMMM"
                                                                                                yearDropdownItemNumber={15}
                                                                                                scrollableYearDropdown
                                                                                                
                                                                                                fixedHeight name="uploadDate" dateFormat="dd/MM/yyyy" className="form-control" />
                                                                                        </td>
                                                                                        <td>
                                                                                            <input type="text" name="documentDetail" value={imageUploadList[idx].name} onChange={handleNameChange(idx)} className="form-control" />
                                                                                        </td>
                                                                                        <td>
                                                                                            <input type="textarea" name="documentDetail" value={imageUploadList[idx].detail} onChange={handleDetailChange(idx)} className="form-control" />
                                                                                        </td>
                                                                                        <td>
                                                                                            <img src={item.imageRelativePath} className="image-popup-thumbnail" alt={item.imageName}
                                                                                                onClick={(event, imageName, imageUrl) => handleImageViewPopup(event, item.imageName, item.imageRelativePath)}></img>
                                                                                        </td>
                                                                                        <td style={{ width: "15%" }}>
                                                                                            {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                                                                <>
                                                                                                    {imageUploadList[idx].imageRelativePath != null && imageUploadList[idx].imageRelativePath != '' ?
                                                                                                        <Button style={{ float: `right` }} color="warning" size="sm" onClick={(e) => handleBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                                                                        :
                                                                                                        <Button style={{ float: `right` }} color="success" size="sm" onClick={(e) => handleBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                                                                    }
                                                                                                    <br />
                                                                                                    <input style={{ float: `right`, display: 'none' }}
                                                                                                        ref={input => {
                                                                                                            inputFile[idx] = input;
                                                                                                        }}
                                                                                                        type="file" name="attachment" className="form-control" onChange={(e) => handleImageChange(e, idx)} />
                                                                                                    {formErrors.length > 0 && formErrors[idx] != undefined && formErrors[idx].fileError != undefined &&
                                                                                                        <p className="errorMessage">{formErrors[idx].fileError}</p>
                                                                                                    }
                                                                                                </>
                                                                                            }
                                                                                        </td>
                                                                                        <td>
                                                                                            {(roleName == 'SWNZ Admin' || imageUploadList[idx].id == 0 || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                                                                <>
                                                                                                    <button type="button" id="btnUpdate" className="btn btn-sm btn-danger" onClick={() => openDeleteItemPopup(item)}><FaTrash /></button>
                                                                                                </>
                                                                                            }
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        }
                                                                    </Table>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <button onClick={handleRecordRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse-light">
                                                                Add Map
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                    </CardBody>
                                                </Collapse>
                                            </Card>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            
                            <Row>
                                <BiodiversityInfo setSignificantBiodiversityChanged={setSignificantBiodiversityChanged} biodiversityDesc={biodiversityDesc} setBiodiversityDesc={setBiodiversityDesc}  SectionObj={catchmentContext.SectionObj} />
                            </Row>
                        </Col>

                    </Row>
                    <Row>
                        <Col>
                            <Row>
                                <Col>
                                    <Card className="my-4">
                                        <CardHeader className="item-header card-header-click card-header-outline" onClick={toggle}>
                                            <Row>
                                                <Col sm="6">
                                                    <h5>Surface Water Quality&nbsp;&nbsp;&nbsp;
                                                        <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-5" onClick={(e) => e.stopPropagation()} /></h5>
                                                    <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                                        id="my-tooltip-5"
                                                        place="top"
                                                        variant="info"
                                                        render={({ content, activeAnchor }) => (
                                                            <>
                                                                <Row>
                                                                    <Col>
                                                                        <p style={{ fontWeight: "lighter" }}>
                                                                            Go to the LAWA website <a href="https://www.lawa.org.nz" target="_blank" rel="noreferrer">https://www.lawa.org.nz</a> to ascertain ground water quality of waterways near your property, particularly those downstream of your property.
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )}
                                                    />
                                                </Col>
                                                <Col sm="5">
                                                    <label style={{ float: "right", marginLeft: "10px", color: "white" }} className="outlineLabel form-label" htmlFor="notRelevantToThisProperty">
                                                        Not relevant to this property
                                                    </label>
                                                    <input style={{ float: "right" }} disabled={(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') ? false : true} className="islargeEnterprise form-check-input" id="notRelevantToThisProperty" value={notRelevantToThisProperty} checked={notRelevantToThisProperty} type="checkbox" onChange={handleNotRelevantToThisProperty} />
                                                </Col>
                                                <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                            </Row>
                                        </CardHeader>
                                        <Collapse isOpen={isOpen && !notRelevantToThisProperty}>
                                            <CardBody>
                                                <FarmApt elementRef={elementRef} elementRef1={elementRef1} elementRef2={elementRef2} farmDetails={farmDetails} />
                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="6">
                                    {catchmentContext.SectionObj.isDocumentUploadReq &&
                                        <Documents refid={catchmentContext.SectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
            }

            <Modal isOpen={showDeleteItemPopup}>
                <ModalHeader>Delete the item</ModalHeader>
                <ModalBody>
                    Do you want to delete the item ?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmDeleteItemPopup}>Yes</Button>
                    <Button color="danger" onClick={closeDeleteItemPopup}>No</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={imageViewPopup.showImageViewPopup} size="lg" className="imageViewPopup">
                <ModalHeader toggle={handleImageViewPopupClose} >{imageViewPopup.imageName}</ModalHeader>
                <ModalBody>
                    <img src={imageViewPopup.imageUrl} className="item-image-popup" alt={imageViewPopup.imageName} ></img>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleImageViewPopupClose}>Close</Button>
                </ModalFooter>
            </Modal>

        </div>
    )
}

export default CatchmentContext;